import { get } from 'lodash';

const variableRegex = /\{\{\s*([\w.]+)\s*\}\}/g;
const ifDefBlockRegex = /<#ifdef\s*([\w.]+)(?:\s*&&\s*([\w.]+))*\s*>\n([\s\S]*?)\n<#endif>/g;
const ifTrueBlockRegex = /<#ifTrue\s*([\w.]+)(?:\s*&&\s*([\w.]+))*\s*>\n([\s\S]*?)\n<#endif>/g;
const sanitizationRegex = /([[\]()#*_])/g;

export function prepare(markdown, properties, definitions) {
    let modifiedMarkdown;
    modifiedMarkdown = handleIfDefConditionalContent(markdown, properties);
    modifiedMarkdown = handleIfTrueConditionalContent(modifiedMarkdown, properties);
    modifiedMarkdown = replaceVariablesWithValues(modifiedMarkdown, properties, definitions);
    return modifiedMarkdown;
}

function sanitizeValue(val = '') {
    return val.replace(sanitizationRegex, '\\$1');
}

function replaceVariablesWithValues(markdown, properties, definitions) {
    return markdown.replace(variableRegex, getValuesFromProperties);

    function getValuesFromProperties(match, p1) {
        const val = get(properties, p1, '');
        if (definitions) {
            // can choose a language here in the future
            const language = definitions.default;
            return sanitizeValue(get(language, val, val));
        }
        return sanitizeValue(val);
    }
}

function handleIfDefConditionalContent(markdown, properties) {
    return markdown.replace(ifDefBlockRegex, determineIfBlocks);

    function determineIfBlocks(match, ...groups) {
        let conditional;
        for (let ii = 0; ii < groups.length - 3; ii++) {
            if (typeof groups[ii] !== 'undefined') {
                conditional = get(properties, groups[ii], '');
                if (!conditional) {
                    return '';
                }
            }
        }
        return groups[groups.length - 3];
    }
}

function handleIfTrueConditionalContent(markdown, properties) {
    return markdown.replace(ifTrueBlockRegex, determineIfBlocks);

    function determineIfBlocks(match, ...groups) {
        let conditional;
        for (let ii = 0; ii < groups.length - 3; ii++) {
            if (typeof groups[ii] !== 'undefined') {
                conditional = get(properties, groups[ii], '');
                if (conditional !== 'true' && conditional !== true) {
                    return '';
                }
            }
        }
        return groups[groups.length - 3];
    }
}
